"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Builder = _interopRequireDefault(require("./Builder"));
var _settings = require("./Builder/settings.js");
var _Player = _interopRequireDefault(require("./Player"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  code: 'fileUpload',
  name: 'File upload',
  labelField: 'question',
  icon: _settings.icon,
  builder: _Builder["default"],
  builderInitialValues: _settings.initialValues,
  player: _Player["default"],
  getDataDefinitions: _settings.getDataDefinitions,
  getMetrics: _settings.getMetrics,
  isSkipped: _settings.isSkipped,
  getDataConnectors: _settings.getDataConnectors,
  getDataConnectorsValues: _settings.getDataConnectorsValues
};